<template>
  <div id="app">
    <transition
        name="fade"
        mode="out-in"
    >
      <router-view/>
    </transition>
    <Navbar/>
    <Footer/>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default {
  name: 'App',
  components: {Navbar, Footer},
  created() {
  },
  computed: {
  },
  methods: {
  }
}
</script>
